import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { capitalize } from "lodash";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "twin.macro";

type ItemHeadingProps = {
  brand: any;
  season: any;
  line?: any;
  item: any;
};

export const ItemHeading: React.FC<ItemHeadingProps> = (props) => {
  const { brand, season, line, item } = props;

  const { i18n } = useTranslation();
  const languageSuffix = capitalize(i18n.language);

  return (
    <div>
      <div tw="flex w-full justify-between px-6">
        <div tw="text-gray-500">
          <Link to="/" tw="hover:(text-gray-900)">
            {brand[`name${languageSuffix}`].toUpperCase()}
          </Link>
          <FontAwesomeIcon icon={faChevronRight} tw="mx-2" />
          <Link to={`/b/${brand.id}/s/${season.id}`} tw="hover:(text-gray-900)">
            {`${season[`name${languageSuffix}`]} ${season[`kind${languageSuffix}`]}`.toUpperCase()}
          </Link>
          {line && (
            <Fragment>
              <FontAwesomeIcon icon={faChevronRight} tw="mx-2" />
              <Link to={`/b/${brand.id}/s/${season.id}/l/${line.id}`} tw="hover:(text-gray-900)">
                {`${line[`name${languageSuffix}`]}`.toUpperCase()}
              </Link>
            </Fragment>
          )}
          <FontAwesomeIcon icon={faChevronRight} tw="mx-2" />
          <Link to={`/b/${brand.id}/s/${season.id}/i/${item.id}`} tw="hover:(text-gray-900)">
            {item[`name${languageSuffix}`].toUpperCase()}
          </Link>
        </div>
      </div>
    </div>
  );
};
